import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'

interface SegmentedProgressProps {
  current: number
  total: number
  label?: string
  dataQsId: string
  className?: string
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
  segments: {
    display: 'flex',
    gap: 6,
    width: '100%',
  },
  segment: {
    flex: 1,
    height: 4,
    borderRadius: theme.borderRadiusPill,
    backgroundColor: theme.palette.brand.divider,
    transition: 'background-color 0.3s ease-in-out',
  },
  active: {
    backgroundColor: theme.palette.brand.main,
  },
  label: {
    fontSize: theme.brandTypography.text.small.fontSize,
    fontWeight: theme.brandTypography.weights.medium,
    color: theme.palette.brand.text.secondary,
  },
}))

const SegmentedProgress = ({ current, total, label, dataQsId, className }: SegmentedProgressProps) => {
  const classes = useStyles()
  const segments = Array.from({ length: Math.max(total, 0) }, (_, index) => index < current)

  return (
    <div className={clsx(classes.container, className)} data-qs-id={dataQsId}>
      <div
        className={classes.segments}
        role='progressbar'
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={current}
        aria-valuetext={label}
      >
        {segments.map((isActive, index) => (
          <span key={index} className={clsx(classes.segment, isActive && classes.active)} data-qs-id={`${dataQsId}-segment-${index + 1}`} />
        ))}
      </div>
      {label && <span className={classes.label}>{label}</span>}
    </div>
  )
}

export default SegmentedProgress
